import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageItem } from 'store';
import FlashMessage from '@/modules/messaging/components/flash-message/flash-message.vue';

@Component({
	components: {
		'flash-message': FlashMessage
	}
})
export default class FlashMessagesList extends Vue {
	@Prop({
		default() {
			return [];
		}
	})
	messages!: Array<MessageItem>;

	removeFlashMessage(messageId: string): void {
		this.$emit('message:remove', messageId);
	}
}
